import {AfterViewInit, Directive, ElementRef, HostListener} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {filter, throttleTime} from 'rxjs/operators';

@Directive({
  selector: '[appMousemove]'
})
export class MousemoveDirective implements AfterViewInit {
  public mouseOverElement: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  scrHeight = 720;
  scrWidth = 1280;

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(): void {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent): void {
    this.mouseOverElement.next(e);
  }

  ngAfterViewInit(): void {
    this.mouseOverElement
      .pipe(
        filter((c) => c !== null),
        throttleTime(50),
      )
      .subscribe(event => {
        const halfHeight = this.scrHeight / 2;
        const halfWidth = this.scrWidth / 2;
        this.elementRef.nativeElement.querySelectorAll('#scooter').forEach((cloudElRef: any) => {
          const scooterTransitionX = -(event.clientX - halfWidth) / 10;
          cloudElRef.style.transition = 'all .2s';
          cloudElRef.style.transform = 'translateX(' + scooterTransitionX + 'px) ';
        });
        this.elementRef.nativeElement.querySelectorAll('#cloud').forEach((cloudElRef: any) => {
          cloudElRef.style.transition = 'all .2s';
          const transitionX = -(event.clientX - halfWidth) / 10;
          const transitionY = -(event.clientY - halfHeight) / 10;
          cloudElRef.style.transform
            = 'translate(' + transitionX.toString() + 'px ,' + transitionY.toString() + 'px )';
        });
      });
  }
}
